module.exports = __webpack_public_path__ + "img/02.9ba65e57.png";